import React, { createContext, useContext, useState, useEffect } from "react";
import Api from "./baseApi";

export const Context = createContext(null);
export const useConfig = () => useContext(Context);

export default function ConfigProvider({ configCode, children }) {
  const [conf, confSet] = useState(false);
  const [error, errorSet] = useState(false);

  const load = () => {
    errorSet(false);
    const [query] = Api.GET({ path: `/api/vel/config?code=${configCode}` });
    query
      .then((rest) => {
        rest.places.forEach((p) => {
          if (p.notifyMail) p.notifyMail = [p.notifyMail];
        });
        const config = {
          places: { values: rest.places },
          code: configCode,
        };

        if (rest.defaultOfferUrl) {
          config.defaultOfferUrl = rest.defaultOfferUrl;
        }
        config.defaultLegalContent = rest.defaultLegalContent ?? null;

        let notifyChannel = "onair-fitness";
        let currency = "€";
        let defaultInternationnalCode = "+33";
        let splitPlans = false;
        let footerLogos = [];
        let cgvUrl = "https://onair-fitness.fr/cgv/";
        let baseSite = "https://onair-fitness.fr";

        if (configCode === "onair.es" || configCode === "onair.test") {
          notifyChannel = "onair-fitness-es";
          currency = "€";
          defaultInternationnalCode = "+34";
          window.i18n.changeLanguage("es");
          cgvUrl = "https://www.onair-fitness.es/condiciones-generales-de-venta";
          baseSite = "https://onair-fitness.es";
        }
        if (configCode === "onair.pt") {
          notifyChannel = "onair-fitness-pt";
          currency = "€";
          defaultInternationnalCode = "+351";
          window.i18n.changeLanguage("pt");
          cgvUrl = "https://www.onairfitness.pt/condicoes-gerais-de-venda";
          baseSite = "https://onairfitness.pt";
        }
        if (configCode === "onair.ma") {
          notifyChannel = "onair-fitness-ma";
          currency = "DHS";
          defaultInternationnalCode = "+212";
          splitPlans = true;
          cgvUrl = "https://www.onair-fitness.ma/cgv/";
          footerLogos = ["/logo_cmi.png", "/secure_code_logo.png", "/tn_verified_by_visa.png"];
          baseSite = "https://onair-fitness.ma";
        }

        config.baseSite = baseSite;
        config.notifyChannel = notifyChannel;
        config.currency = currency;
        const codeToCountry = { "+33": "FR", "+34": "ES", "+351": "PT", "+212": "MA", "+262": "FR", "+596": "FR", "+590": "FR" };
        const defaultCountry = codeToCountry[defaultInternationnalCode] || "FR";
        config.phone = { defaultInternationnalCode, defaultCountry };
        config.splitPlans = splitPlans;
        config.footerLogos = footerLogos;
        config.cgvUrl = cgvUrl;
        confSet(config);
      })
      .catch((e) => {
        console.error(e);
        errorSet(true);
      });
  };

  useEffect(() => { load(); }, []);

  if (error) return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: '16px' }}>
      <p>Une erreur est survenue. Veuillez réessayer.</p>
      <button onClick={load} style={{ padding: '8px 16px', cursor: 'pointer' }}>Réessayer</button>
    </div>
  );

  if (!conf) return null;

  return <Context.Provider value={conf}>{children}</Context.Provider>;
}
